import {
  PaymentAPI,
  PaymentProvider,
  PaymentState,
  SetupRecurringPaymentMethodAndPollOptions,
} from '../../typings/Payment'
import { getGoogleSearchParam } from '../../lib/get-google-search-param'
import pollPayment from './poll-payment'

const confirmPaymentSetupAndPoll = async (
  paymentProvider: PaymentProvider,
  paymentAPI: PaymentAPI,
  { orderId, options, lastPaymentAttempt }: SetupRecurringPaymentMethodAndPollOptions,
) => {
  const { elements, user } = options
  const { stripe } = paymentProvider

  if (!stripe || !elements) {
    throw new Error('Stripe provider or element was not found')
  }

  const returnUrl = new URL(
    `${window.location.href}&paymentInProgress=true&isSetupFlow=true&lastPaymentAttempt=${lastPaymentAttempt.getTime()}&isReturningFromStripe=true`,
  )

  const trackingParam = getGoogleSearchParam()

  if (trackingParam) {
    const [trackingName, trackingValue] = trackingParam.split('=')
    returnUrl.searchParams.append(trackingName, trackingValue)
  }

  const { error: confirmSetupError } = await stripe.confirmSetup({
    elements,
    confirmParams: {
      payment_method_data: {
        billing_details: {
          name: `${user.firstName} ${user.lastName}`,
          email: user.email,
        },
      },
      return_url: returnUrl.toString(),
    },
  })

  if (confirmSetupError) {
    return { wasSuccessful: false, error: confirmSetupError.message }
  }

  // the payment state can either transition to
  // - `ON_HOLD` if a mandate was created initially or to
  // - `IN_PROGRESS` if the verified mandate is charge immediately
  return pollPayment(paymentAPI, {
    orderId,
    lastPaymentAttempt,
    additionalExpectedPaymentStates: [PaymentState.PAYMENT_STATE_ON_HOLD, PaymentState.PAYMENT_STATE_IN_PROGRESS],
  })
}

export default confirmPaymentSetupAndPoll
